import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-progress',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Progress icon</title><path d="M23.235 6.825v11.997a.924.924 0 0 1-.419.725l-.393.235c-1.961 1.135-3.687 2.134-5.431 3.14V9.948L5.759 3.454C7.703 2.338 9.64 1.211 11.586.1a.927.927 0 0 1 .837 0l10.81 6.243v.482zm-8.741 4.562A9631.706 9631.706 0 0 0 6.8 6.943a.94.94 0 0 0-.837 0c-1.733 1.001-3.467 2-5.199 3.004l8.113 4.684V24c1.732-.999 3.46-2.006 5.197-2.995a.927.927 0 0 0 .419-.724zM.765 19.317l5.613 3.241V16.07Z"/></svg>`,
    styles: []
})
export class SimpleIconsProgressComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#5CE500';
    @Input() className: string = 'simple-icons-progress'
    constructor() {}
    ngOnInit(): void {}
}
